module.exports = __webpack_public_path__ + "assets/img/detail-head-back-man.8d679177.png";